import React from 'react';
import { getCompanySlug } from '../../../client-experience/utils/companyAccess';
import PortalSlugCooldownAdminSection from './PortalSlugCooldownAdminSection';
import './styles/CompanyProfileContent.css';

const CompanyProfileContent = ({
  company,
  onCompanyUpdated,
  showCompanyId = true,
  showHeader = true
}) => {
  if (!company?.id) {
    return null;
  }

  const portalUrl = getCompanySlug(company) || company?.portalUrl || null;

  return (
    <div className="company-profile-content">
      {showHeader ? (
        <div className="company-profile-content__header">
          <div>
            <h3 className="company-profile-content__title">{company.name || 'Company'}</h3>
            {showCompanyId ? (
              <p className="company-profile-content__meta">Company ID: {company.id}</p>
            ) : null}
          </div>
        </div>
      ) : null}

      <div className={`company-profile-content__fields${showHeader ? '' : ' company-profile-content__fields--compact'}`}>
        <div className="company-profile-content__field">
          <strong>Status:</strong> {company.status || '—'}
        </div>
        <div className="company-profile-content__field">
          <strong>Portal URL:</strong> {portalUrl || '—'}
        </div>
        <div className="company-profile-content__field">
          <strong>Email:</strong> {company.email || '—'}
        </div>
      </div>

      <PortalSlugCooldownAdminSection
        company={company}
        onCompanyUpdated={onCompanyUpdated}
      />
    </div>
  );
};

export default CompanyProfileContent;
